import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, FormGroup } from '@angular/forms';
import { Concessao } from '@tivic-team/manager-ts/dist/mob';
import { ConcessaoTipo } from '@tivic-team/manager-ts/dist/mob/enums/concessao/concessao-tipo.enum';
import { DataValidator } from 'app/tools/custom-formgroup-validator';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'text-data-validade-cnh',
  templateUrl: './text-data-validade-cnh.component.html',
  styleUrls: ['./text-data-validade-cnh.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class TextDataValidadeCnhComponent implements OnInit {

  formGroup: FormGroup;
  @Input() tpConcessao: number;
  now: string = new Date().toISOString().split('T')[0];
  max: string = new Date('9999-12-31').toISOString().split('T')[0];
  
  constructor(
    private _controlContainer: ControlContainer
  ) {}

  ngOnInit() {
    this.formGroup = this._controlContainer.control as FormGroup;
    if(this.tpConcessao != ConcessaoTipo.TAXI) {
      this._validators();
    } else {
      this.setValidator();
    }
  }

  setValidator() {
    const dataAtual: Date = new Date();
    const dataMinima: Date = new Date(dataAtual.getFullYear() - 35, dataAtual.getMonth(), dataAtual.getDate());
    this.formGroup.get('dtValidadeCnh').setValidators([DataValidator.min(dataMinima)]);
  }

  private _validators() {
    const date = new Date();
    date.setHours(23, 59, 59, 59);
    this.formGroup.get('dtValidadeCnh').setValidators([DataValidator.min(date)]);
    this.formGroup.get('dtValidadeCnh').updateValueAndValidity();
  }
}
